/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useState} from 'react';
import {Box, Typography} from '@mui/material';
import {useGetDatComponent} from '../../../hooks/productions/useProductions';
import {GetDatComponentRequestParam} from '../../../api/types/production.type';
import ArrLoadingSpinner from '../../../components/common/arr-loading-spinner/ArrLoadingSpinner';
import ArrSelectDropdown from '../../../components/common/arr-select-dropdown/ArrSingleSelectDropdown';

const DatComponentView: React.FC = () => {
  const [securityGroupId, setSecurityGroupId] = useState<number>(1);

  const [productionId, setProductionId] = useState<number>(30);

  const {
    data: datComponentData,
    isLoading: isDatComponentLoading,
    error: datComponentError,
  } = useGetDatComponent(
    {
      SecurityGroupId: securityGroupId,
      moduletype: 'Production',
      parentsetid: 1,
      productionId: productionId,
      exportProductionId: 0,
    } as GetDatComponentRequestParam,
    true
  );

  if (isDatComponentLoading) {
    return <ArrLoadingSpinner />;
  }

  if (datComponentError) {
    return (
      <Box>
        <Typography color="error">
          Error loading DAT component: {datComponentError.message}
        </Typography>
      </Box>
    );
  }

  return (
    <Box className="dat-component-container">
      <Typography variant="h5" className="typo-text headline3_size">
        DAT Component Configuration
      </Typography>

      <Box className="form-section">
        <Typography className="typo-text label2_size">
          ANSI Format Type
        </Typography>
        <ArrSelectDropdown
          id="ansi-format-dropdown"
          label="Select ANSI Format"
          options={
            datComponentData?.ansiFormatList.map((item) => ({
              value: item.ansiTypeID,
              label: item.ansiTypeLabel,
            })) || []
          }
          value={datComponentData?.modelData?.ansiFormatType || ''}
          onChange={(value) => console.log('ANSI Format changed:', value)}
        />
      </Box>

      <Box className="form-section">
        <Typography className="typo-text label2_size">
          Column Delimiter
        </Typography>
        <ArrSelectDropdown
          id="column-delimiter-dropdown"
          label="Select Column Delimiter"
          options={
            datComponentData?.columnDelimiterList.map((item) => ({
              value: item.value,
              label: item.text,
            })) || []
          }
          value={datComponentData?.modelData?.fieldSeparator?.toString() || ''}
          onChange={(value) => console.log('Column Delimiter changed:', value)}
        />
      </Box>

      <Box className="form-section">
        <Typography className="typo-text label2_size">
          Text Qualifier
        </Typography>
        <ArrSelectDropdown
          id="text-qualifier-dropdown"
          label="Select Text Qualifier"
          options={
            datComponentData?.textQualifierList.map((item) => ({
              value: item.value,
              label: item.text,
            })) || []
          }
          value={datComponentData?.modelData?.textQualifier?.toString() || ''}
          onChange={(value) => console.log('Text Qualifier changed:', value)}
        />
      </Box>

      <Box className="form-section">
        <Typography className="typo-text label2_size">Date Format</Typography>
        <ArrSelectDropdown
          id="date-format-dropdown"
          label="Select Date Format"
          options={
            datComponentData?.dateFormats.map((item) => ({
              value: item.value.toString(),
              label: item.text,
            })) || []
          }
          value={datComponentData?.modelData?.dateFormatID?.toString() || ''}
          onChange={(value) => console.log('Date Format changed:', value)}
        />
      </Box>

      <Box className="mapping-section">
        <Typography className="typo-text subhead2_size">
          Field Mapping Data ({datComponentData?.mappingRowCount || 0} rows)
        </Typography>
        {datComponentData?.modelData?.datFieldMappingDataList.map(
          (mapping, index) => (
            <Box key={index} className="mapping-row">
              <Typography>
                {mapping.datField} - Type: {mapping.selectedTypeId} - Source:{' '}
                {mapping.selectedSourceId}
                {mapping.isPrivileged && ' (Privileged)'}
                {mapping.isRedacted && ' (Redacted)'}
              </Typography>
            </Box>
          )
        )}
      </Box>

      <Box className="settings-section">
        <Typography className="typo-text subhead2_size">Settings</Typography>
        <Typography>
          Is ANSI: {datComponentData?.modelData?.isAnsi ? 'Yes' : 'No'}
        </Typography>
        <Typography>
          Overwrite Master Date:{' '}
          {datComponentData?.modelData?.overwriteMasterDate ? 'Yes' : 'No'}
        </Typography>
        <Typography>
          Prepend Carriage Return:{' '}
          {datComponentData?.modelData?.prependCarriageReturn ? 'Yes' : 'No'}
        </Typography>
        <Typography>
          eText Format: {datComponentData?.modelData?.eTextFormat || 'N/A'}
        </Typography>
      </Box>
    </Box>
  );
};

export default DatComponentView;
